/**
 * Purchase Orders Table Constants
 */

import {
  Clock,
  CheckCircle,
} from '@ufc/uikit'

export type POTableColumnKey =
  | 'poNumber'
  | 'supplier'
  | 'factory'
  | 'materialGroup'
  | 'poDate'
  | 'status'
  | 'receiptStatus'
  | 'received'
  | 'actions'

export interface POTableColumnConfig {
  key: POTableColumnKey
  labelKey: string
  align?: 'start' | 'end'
  width?: string
  locked?: boolean
}

export const PO_TABLE_COLUMNS: POTableColumnConfig[] = [
  { key: 'poNumber', labelKey: 'incomingMaterials.poNumber', locked: true },
  { key: 'supplier', labelKey: 'incomingMaterials.supplier' },
  { key: 'factory', labelKey: 'incomingMaterials.factory' },
  { key: 'materialGroup', labelKey: 'incomingMaterials.materialGroup' },
  { key: 'poDate', labelKey: 'incomingMaterials.poDate' },
  { key: 'status', labelKey: 'incomingMaterials.fields.status' },
  { key: 'actions', labelKey: 'common.actions', align: 'end', width: 'w-[100px]', locked: true },
]

export type POStatus = 'pending' | 'completed'

export const poStatusConfig: Record<POStatus, {
  bg: string
  text: string
  icon: typeof Clock
  dotColor: string
  labelKey: string
}> = {
  pending: {
    bg: 'bg-amber-50 dark:bg-amber-500/10',
    text: 'text-amber-700 dark:text-amber-400',
    icon: Clock,
    dotColor: 'bg-amber-500',
    labelKey: 'incomingMaterials.poStatus.pending',
  },
  completed: {
    bg: 'bg-emerald-50 dark:bg-emerald-500/10',
    text: 'text-emerald-700 dark:text-emerald-400',
    icon: CheckCircle,
    dotColor: 'bg-emerald-500',
    labelKey: 'incomingMaterials.poStatus.completed',
  },
}
